<template>
    <div class="toggle" :class="{ 'label-right': labelAlignment === 'right' }">
        <label :for="id" class="toggle__wrapper">
            <span v-if="labelAlignment === 'left'" class="mr-2 toggle__label">
                {{ switchLabel }} <span v-if="!hideToggleLabel" class="toggle__label-bold"> {{ toggleLabel }}</span>
            </span>
            <span class="toggle__switch">
                <input type="checkbox" value="ON" @change="onSwitchChange" :id="id" :name="id" :checked="isToggled" />
                <span class="toggle__slider round"></span>
            </span>
            <span v-if="labelAlignment === 'right'" class="ml-2 toggle__label"
                >{{ switchLabel }}<span v-if="!hideToggleLabel" class="toggle__label-bold"> {{ toggleLabel }}</span>
            </span>
        </label>
    </div>
</template>

<script lang="ts">
export default {
    name: 'SwitchToggle',

    props: {
        label: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: '',
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
        labelAlignment: {
            type: String,
            default: 'left', // Default alignment is left
            validator: (value) => ['left', 'right'].includes(value),
        },
        hideToggleLabel: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isToggled: this.isSelected,
            switchLabel: '',
            toggleLabel: '',
        };
    },
    watch: {
        isSelected: {
            handler(selected) {
                this.isToggled = selected;
                this.switchLabel = this.getLabelValue();
                this.toggleLabel = this.getToggleLabelValue();
            },
            deep: true,
            immediate: true,
        },
    },

    methods: {
        onSwitchChange(e: any) {
            let vm = this;
            let el = e.target as HTMLInputElement;
            this.isToggled = el.checked;
            this.switchLabel = this.getLabelValue();
            this.toggleLabel = this.getToggleLabelValue();
            vm.$emit('onSwitchChange', el.checked);
        },
        getToggleLabelValue() {
            if (this.hideToggleLabel) {
                return '';
            } else {
                return this.isToggled ? 'ON' : 'OFF';
            }
        },
        getLabelValue() {
            if (!!this.label) {
                return this.label;
            }
        },
    },
};
</script>
